import { CSSProperties } from "react";
import { CmsBackgroundType } from "@talladega/types";
import cloudflareImagesLoader from "../cloudflareImagesLoader";
import { IsNodeStructure } from "./acfImageTypeResolver";

const DEFAULT_BACKGROUND_WIDTH = 1920;

export const GetBackgroundStyle = (
  background: CmsBackgroundType,
  baseDomain: string
): CSSProperties | undefined => {
  if (background.option === "Color") {
    if (
      background.secondaryBackground.active &&
      background.secondaryBackground.secondaryBackgroundColor
    ) {
      return {
        background: `linear-gradient(${
          background.secondaryBackground.backgroundDirection === "On Bottom"
            ? "to top"
            : "to bottom"
        }, ${background.secondaryBackground.secondaryBackgroundColor} ${
          background.secondaryBackground.backgroundPercentage ?? "40"
        }%, ${background.backgroundColor ?? "transparent"} ${
          background.secondaryBackground.backgroundPercentage ?? "40"
        }%)`,
      };
    }
    return {
      backgroundColor: background.backgroundColor ?? "transparent",
    };
  }

  if (background.option === "Image" && background.backgroundImage) {
    const { sourceUrl } =
      (IsNodeStructure(background.backgroundImage)
        ? background.backgroundImage.node
        : background.backgroundImage) ?? {};

    return {
      backgroundImage: `url(${cloudflareImagesLoader({
        src: sourceUrl ?? "",
        width: DEFAULT_BACKGROUND_WIDTH,
        baseDomain,
      })})`,
    };
  }

  return undefined;
};

export default {};
